export const WASTE_VALIDATION = {
  MAX_STREAM_NAME_LENGTH: 32,
  MIN_DISTRIBUTION_VALUE: 0.01,
  MIN_MOISTURE_PERCENT: 0,
  MAX_MOISTURE_PERCENT: 100,
  DISTRIBUTION_TOLERANCE: 0.01
} as const;

export const WASTE_MANAGEMENT_TYPE_IDS = {
  RECOVERED_FOR_USE_OR_SALE: "1"
} as const;

export const WASTE_VALIDATION_MESSAGES = {
  FILL_REQUIRED_FIELDS: "Please fill out all required fields correctly.",
  STREAM_NAME_REQUIRED: "Stream name is required!",
  STREAM_NAME_TOO_LONG: `Stream name cannot exceed ${WASTE_VALIDATION.MAX_STREAM_NAME_LENGTH} characters`,
  DISTRIBUTION_POSITIVE: "Side Streams Distribution must be greater than 0",
  DISTRIBUTION_REQUIRED: "Distribution is required"
} as const;
